import request from '../utils/request'
import { getToken } from '../utils/auth'

export function fetchTFAMInfoList(filter) {
  return request({
    url: '/api/tfam_infos',
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function fetchTFAMInfo(id, filter) {
  return request({
    url: '/api/tfam_infos/' + id,
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function createTFAMInfo(data) {
  return request({
    url: '/api/tfam_infos',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function updateTFAMInfo(id, data) {
  return request({
    url: '/api/tfam_infos/' + id,
    method: 'patch',
    params: {
      'access_token': getToken()
    },
    data
  })
}
